import type { ComponentProps } from 'react'
import type TextButton from 'LuxKit/Button/TextButton'
import type IconButton from 'LuxKit/Button/IconButton'

export type SocialLoginButtonVariant = NonNullable<ComponentProps<typeof TextButton>['variant']>

export const SOCIAL_LOGIN_TEXT_BUTTON_PROPS: Omit<ComponentProps<typeof TextButton>, 'children'> = {
  fit: 'full-width',
  kind: 'secondary',
  size: 'medium',
  variant: 'default',
}

export const SOCIAL_LOGIN_ICON_BUTTON_PROPS: Omit<ComponentProps<typeof IconButton>, 'children'> = {
  kind: 'secondary',
  size: 'large',
  variant: 'default',
}
